import React from 'react';
import styled from 'styled-components';
import { Body5, Container } from '@ui';
import { ResultOnly } from './components/AnswerLine';
import { Working } from '@ui/Working';
import { useSelector } from 'react-redux';
import AgentChatAnswer from './AgentChatAnswer';

const ChatHistoryWrapper = styled.div`
  padding: 16px 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const UserQuestionWrapper = styled.div`
  background-color: ${({ theme }) => theme.themeColors.border};
  color: ${({ theme }) => theme.themeColors.text};
  border-radius: 20px 20px 4px 20px;
  padding: 12px 18px;
  max-width: 70%;
  margin-left: auto;
  margin-bottom: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  font-size: 1rem;
  word-break: break-word;
  align-self: flex-end;
  display: inline-block;
`;
const UserQuestionPosition = styled.div`
  display: flex;
  justify-content: flex-end;
`;
const AnswerWrapper = styled.div`
  background-color: ${({ theme }) => theme.themeColors.componentNoOpacity};
  border-radius: 16px;
  padding: 16px;
`;

const AgentAnswerResult = ({ resultId, tool }) => {
  const result = useSelector((state) => state.chatHistory.answerLookup[resultId] || {});
  const { answer, error, executedPlan } = result;

  if (error) {
    return (
      <Container bottom={16}>
        <Body5>An error occurred while answering your request. Please re-enter your question and try again.</Body5>
      </Container>
    );
  }

  return <AgentChatAnswer answer={answer} resultId={resultId} tool={tool} />;
};

const NonAgentAnswerResult = ({ resultId, tool }) => {
  const result = useSelector((state) => state.chatHistory.answerLookup[resultId] || {});
  const { answer, error, executedPlan } = result;

  if (error) {
    return (
      <Container bottom={16}>
        <Body5>An error occurred while answering your request. Please re-enter your question and try again.</Body5>
      </Container>
    );
  }

  if (!answer) {
    return <Working />;
  }
  return <ResultOnly result={answer} resultId={resultId} tool={tool} />;
};

const ChatHistoryAnswer = ({ resultId, tool, disableAgent }) => {
  return (
    <AnswerWrapper>
      {disableAgent ? (
        <NonAgentAnswerResult resultId={resultId} tool={tool} />
      ) : (
        <AgentAnswerResult resultId={resultId} tool={tool} />
      )}
    </AnswerWrapper>
  );
};

const ChatHistoryItem = ({ data, tool, disableAgent }) => {
  const { type, question, resultId, error } = data;
  if (error && !resultId) {
    return (
      <Container>
        <Body5>Something went wrong, try re-entering your question and submit again.</Body5>
      </Container>
    );
  }
  if (type === 'question') {
    return (
      <UserQuestionPosition>
        <UserQuestionWrapper>
          <Body5>{question}</Body5>
        </UserQuestionWrapper>
      </UserQuestionPosition>
    );
  }
  return <ChatHistoryAnswer resultId={resultId} tool={tool} disableAgent={disableAgent} />;
};

const ChatHistory = ({ chatHistoryData, tool, disableAgent }) => {
  return (
    <ChatHistoryWrapper>
      {chatHistoryData.map((item, index) => (
        <ChatHistoryItem key={index} data={item} tool={tool} disableAgent={disableAgent} />
      ))}
    </ChatHistoryWrapper>
  );
};

export default ChatHistory;
